import {
  createContext,
  type PropsWithChildren,
  useMemo,
  useState
} from 'react';
import type { InternalLinksGroups } from '~/contracts/home';

export type InternalLinkContextType = {
  internalLinksGroups: InternalLinksGroups;
};

export const defaultInternalLinkContext: InternalLinkContextType = {
  internalLinksGroups: {}
};

const InternalLinkContext = createContext<InternalLinkContextType>(
  defaultInternalLinkContext
);

export type OwnProps = PropsWithChildren<{
  internalLinksGroups: InternalLinksGroups;
}>;

export function InternalLinkContextProvider(props: OwnProps) {
  const [internalLinksGroups] = useState(props.internalLinksGroups);

  const value = useMemo(
    () => ({
      internalLinksGroups
    }),
    [internalLinksGroups]
  );

  return (
    <InternalLinkContext.Provider value={value}>
      {props.children}
    </InternalLinkContext.Provider>
  );
}

InternalLinkContextProvider.displayName = 'InternalLinkContextProvider';

export default InternalLinkContext;
